// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"04934148","265":"dc5c80c8","446":"99a8a756","827":"2c4b9d92","879":"fed7e144","929":"e5043910"}[chunkId] + ".chunk.js";
};